import styled from 'styled-components'

interface DivProps {
  secondary?: boolean
}

export const Container = styled.div`
  position: relative;
  padding-block: 32px;
  padding-inline: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;

  @media (max-width: 767px) {
    padding-block: 0;
  }
`

export const Row = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  left: 32px;
`

export const QuickView = styled.img`
  cursor: pointer;
  margin-left: 8px;
  @media (max-width: 698px) {
    ${({ secondary }: DivProps) => secondary ? `
    margin-left: 0;
    position: absolute;
    left: -14px;
    top: -36px;
  ` : ''}
  }
`

export const Model = styled.div`
  color: #5f6062;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
`

export const Title = styled.div`
  color: ${({ secondary }: DivProps) => secondary ? 'black' : '#5f6062'};
  font-size: 20px;
  font-weight: bold;
  line-height: 27px;
  @media (max-width: 698px) {
    font-size: 18px;
    margin-top: 4px;
  }
`

export const CenterDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Message = styled.div`
  margin-top: 10px;
  color: ${({ secondary }: DivProps) => secondary ? 'black' : '#8c8c8c'};
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  width: 60%;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterInfo/styledComponents.tsx